module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toch"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#mannu1",
      "id": "tannu1"
    }
  }, [_vm._v("1. Why Socialism? (1949)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#mannu2",
      "id": "tannu2"
    }
  }, [_vm._v("2. The Negro Question (1946)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#mannu3",
      "id": "tannu3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Science and Society (1935)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#mannu4",
      "id": "tannu4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Towards a World Government (1946)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#mannu5",
      "id": "tannu5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Way Out (1946)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#mannu6",
      "id": "tannu6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. On Receiving the One World Award (1948)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#mannu7",
      "id": "tannu7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Science and Civilization (1933)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#mannu8",
      "id": "tannu8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. A Message to Intellectuals (1948)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#mannu9",
      "id": "tannu9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Open Letter to the General Assembly of the United Nations (1947)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#mannu10",
      "id": "tannu10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Dr. Einstein’s Mistaken Notions—An Open Letter from Sergei Vavilov, A. N."), _c('br'), _vm._v("Frumkin, A. F. Joffe, and N. N. Semyonov (1947)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#mannu10a",
      "id": "tannu10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Reply to the Soviet Scientists (1948)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#mannu11",
      "id": "tannu11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. For an Organization of Intellectual Workers (1945)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#mannu12",
      "id": "tannu12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. “Was Europe a Success?” (1934)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#mannu13",
      "id": "tannu13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. At a Gathering for Freedom of Opinion (1936)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#mannu14",
      "id": "tannu14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Atomic War or Peace (I-1945;")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chap14#mannu141a",
      "id": "tannu141a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II-1947)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#mannu15",
      "id": "tannu15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The War Is Won but Peace Is Not (1945)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#mannu16",
      "id": "tannu16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Menace of Mass Destruction (1947)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#mannu17",
      "id": "tannu17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Schools and the Problem of Peace (1934)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#mannu18",
      "id": "tannu18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. On Military Service (1934)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap19#mannu19",
      "id": "tannu19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Military Intrusion in Science (1947)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap19#mannu19a",
      "id": "tannu19a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Military Mentality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap20#mannu20",
      "id": "tannu20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. International Security (1933)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap21#mannu21",
      "id": "tannu21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Isaac Newton (1942)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap22#mannu22",
      "id": "tannu22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Johannes Kepler (1949)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap23#mannu23",
      "id": "tannu23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Marie Curie in Memoriam (1935)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap24#mannu24",
      "id": "tannu24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Max Planck in Memoriam (1948)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap25#mannu25",
      "id": "tannu25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Paul Langevin in Memoriam (1947)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap26#mannu26",
      "id": "tannu26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Walther Nernst in Memoriam (1942)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap27#mannu27",
      "id": "tannu27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Paul Ehrenfest in Memoriam (1934)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap28#mannu28",
      "id": "tannu28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Mahatma Gandhi (1939)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap29#mannu29",
      "id": "tannu29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Carl von Ossietzky (1946)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap30#mannu30",
      "id": "tannu30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Why Do They Hate the Jews? (1938)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap30#mannu30a",
      "id": "tannu30a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just What Is a Jew?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap30#mannu30b",
      "id": "tannu30b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Oppression Is a Stimulus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap31#mannu31",
      "id": "tannu31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. The Dispersal of European Jewry (1948)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap32#mannu32",
      "id": "tannu32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Let’s Not Forget (1934)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap33#mannu33",
      "id": "tannu33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Unpublished Preface to a Blackbook (1945)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap34#mannu34",
      "id": "tannu34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. The Goal of Human Existence (1943)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap35#mannu35",
      "id": "tannu35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Our Debt to Zionism (1938)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap36#mannu36",
      "id": "tannu36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. To the Heroes of the Battle of the Warsaw Ghetto (1944)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap37#mannu37",
      "id": "tannu37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Before the Monument to the Martyred Jews of the Warsaw Ghetto (1948)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap38#mannu38",
      "id": "tannu38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. The Calling of the Jews (1936)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap39#mannu39",
      "id": "tannu39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Moses Maimonides (1935)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap40#mannu40",
      "id": "tannu40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Stephen Wise (1949)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap41#mannu41",
      "id": "tannu41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. To the University of Jerusalem (1949)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap42#mannu42",
      "id": "tannu42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. The American Council for Judaism (1945)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap43#mannu43",
      "id": "tannu43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. The Jews of Israel (1949)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bio",
      "id": "bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Albert Einstein")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ack#mannu45",
      "id": "tannu45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-980d9f98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 66
// module chunks = 0